import { ReactNode } from 'react';
import { Typography } from '@mui/material';

/**
 * @heading1: Label Wrapper
 * @heading3: Interface
 * @heading4: Label Props
 * @ol:
 * label {string}
 * isMandatory {boolean}(optional)
 * showError {boolean}(optional)
 * errorText {string}(optional)
 * @separator:
 */

interface LabelWrapperInterface {
    label: string | ReactNode;
    isMandatory?: boolean;
    showError?: boolean;
    errorText?: string;
    [key: string]: unknown;
}

/**
 * @heading2: LabelWrapper Component
 * @block_quotes: A reusable label wrapper with support for mandatory indicators and error messages.
 * @heading3: Parameter {LabelWrapperInterface} props
 * @block_quotes: Props for configuring the label.
 */

const LabelWrapper: React.FC<LabelWrapperInterface> = ({
    label,
    isMandatory = false,
    showError = false,
    errorText,
    // isMarginApplied=true
    ...props
}: LabelWrapperInterface) => {
    return (
        <Typography
            fontWeight="600"
            fontSize="14px"
            lineHeight="1.3rem"
            marginBottom="0.5rem"
            variant="body1"
            sx={{
                'color': (theme) => (theme.palette.mode === 'dark' ? 'white' : '#444f67'),
                '&.label_error': {
                    color: 'red'
                }
            }}
            {...props}
        >
            {label}
            {isMandatory && (
                <Typography component="span" variant="body2" color="error">
                    *
                </Typography>
            )}
            {showError && (
                <Typography
                    component="span"
                    variant="body2"
                    fontSize="0.7rem"
                    marginLeft="10px"
                    color="error"
                >
                    {errorText}
                </Typography>
            )}
        </Typography>
    );
};

export default LabelWrapper;
